'use client';

import { type FC } from 'react';
import FixedCard from '@/components/atoms/MobileFixedCard/FixedCard';
import useFixedCard from '@/store/useFixedCard';
import dynamic from 'next/dynamic';
import OrderCard from './OrderCard';

const RateDetails = dynamic(() => import('./RateDetails'));
const IndexCard = dynamic(() => import('./IndexCard'));

enum CardComponent {
  RATE_DETAILS = 'RateDetails',
  INDEX = 'index-card',
  ORDER = 'order-card'
}

const CONFIG = {
  [CardComponent.RATE_DETAILS]: {
    bgClassName: 'bottom-0 left-0',
    contentClassName: 'bottom-0 left-0',
    contentHeight: 'h-[calc(100vh-80px)]',
    contentWidth: 'w-full',
    children: <RateDetails />,
    isOverlayBottomNavigator: true
  },
  [CardComponent.INDEX]: {
    bgClassName: 'bottom-12 left-0',
    contentClassName: 'bottom-12 left-0',
    contentHeight: 'h-[315px]',
    contentWidth: 'w-full',
    children: <IndexCard />,
    isOverlayBottomNavigator: false
  },
  [CardComponent.ORDER]: {
    bgClassName: 'bottom-12 left-0',
    contentClassName: 'bottom-12 left-0',
    contentHeight: 'h-[336px]',
    contentWidth: 'w-full',
    children: <OrderCard />,
    isOverlayBottomNavigator: false
  }
};

const MobileFixedCard: FC = () => {
  const { component, clearFixedCard } = useFixedCard();
  const currentComponent = component as CardComponent;
  const isOpen = Object.keys(CONFIG).includes(currentComponent);

  return (
    <FixedCard isOpen={isOpen} onClickOutside={clearFixedCard} {...CONFIG[currentComponent]}>
      {CONFIG[currentComponent]?.children}
    </FixedCard>
  );
};

export default MobileFixedCard;
